import { CheckboxProps } from './Checkbox.types';
import { CheckboxContainer, Label } from './Checkbox.styled';
import { Checkbox as CheckboxComponent } from '@fluentui/react-components';

export const Checkbox = ({ value, label, checked, cb }: CheckboxProps) => {
  const checkboxContainerClick = () => {
    cb(value);
  };
  return (
    <CheckboxContainer onClick={checkboxContainerClick}>
      <Label>{label}</Label>
      <CheckboxComponent checked={checked} />
    </CheckboxContainer>
  );
};
